import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "-1 -1 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.65 11a8.35 8.35 0 1 1 16.7 0 8.35 8.35 0 0 1-16.7 0M11 .85C5.394.85.85 5.394.85 11S5.394 21.15 11 21.15 21.15 16.606 21.15 11 16.606.85 11 .85m-1 5.675a1 1 0 1 0 1.001-1h-.002a1 1 0 0 0-1 1m1 9.847a.75.75 0 0 1-.75-.75V9.945a.75.75 0 0 1 1.5 0v5.676a.75.75 0 0 1-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }